// Fallback data shown only if /api/github is unreachable (e.g. local `npm start` without `vercel dev`).
// In production the GitHub section is fed live by api/github.js.

export const LANGUAGES = [
  { name: 'TypeScript', pct: 38, repos: [] },
  { name: 'Kotlin', pct: 22, repos: [] },
  { name: 'Dart', pct: 15, repos: [] },
  { name: 'SQL', pct: 10, repos: [] },
  { name: 'Python', pct: 8, repos: [] },
  { name: 'Java', pct: 4, repos: [] },
  { name: 'HCL', pct: 3, repos: [] },
];

export const REPOS = [
  { name: 'teli-ai / earnie-v2', description: 'Multi-tenant employee rewards & gamification SaaS.', language: 'TypeScript', isPrivate: true, pushedAt: null, commits: null, url: null },
  { name: 'teli-ai / win-it-all', description: 'Real-money sports pool platform — Flutter, Kotlin/Spring Boot, Azure.', language: 'Kotlin', isPrivate: true, pushedAt: null, commits: null, url: null },
  { name: 'YNAL7711/Whitman-rides', description: null, language: 'TypeScript', isPrivate: false, pushedAt: '2026-01-01', commits: null, url: 'https://github.com/YNAL7711/Whitman-rides' },
];

// Private repos can't be linked on GitHub, so map them to a public product page instead.
// Keys are matched case-insensitively as substrings of the repo's nameWithOwner.
export const PRODUCT_LINKS = [
  { match: 'earnie', url: 'https://earniexp.com/', label: 'earniexp.com' },
  { match: 'winitall', url: 'https://www.winitall.com/', label: 'winitall.com' },
  { match: 'win-it-all', url: 'https://www.winitall.com/', label: 'winitall.com' },
  { match: 'flow', url: 'https://www.winitall.com/', label: 'winitall.com' },
];

// Repos to hide from "What I'm Working On" even if you committed to them this year.
// Matched case-insensitively against the full "owner/name".
export const HIDDEN_REPOS = [
  'YNAL7711/yousef-portfolio',
  'YNAL7711/Whitman-rides',
  'YNAL7711/SQL-data-analysis',
  'YNAL7711/My-todo-list',
];
